import { useEffect, useRef, useState } from "react";

import Modal from "../../Modal";
import EscapeHandler from "../../../utils/escapeHandler";

const monthFormatter = new Intl.DateTimeFormat("pt-BR", {
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

const competenceLabel = (competence) => {
  const [year, month] = String(competence ?? "").split("-").map(Number);
  if (!year || !month) return competence;
  const label = monthFormatter.format(new Date(Date.UTC(year, month - 1, 1)));
  return `${label.charAt(0).toUpperCase()}${label.slice(1)}`;
};

// Fluxo próprio da análise com IA: o mês é escolhido aqui, nunca pelo
// drill-down do gráfico (barChartDate) — essa escolha não altera os filtros
// da tela (PERIODO, tabela, gráfico).
const FinancialMonthPickerDialog = ({ competences, value, onConfirm, onClose }) => {
  const selectRef = useRef(null);
  const [selected, setSelected] = useState(value && competences.includes(value) ? value : (competences[competences.length - 1] ?? ""));

  useEffect(() => {
    selectRef.current?.focus();
  }, []);

  const hasOptions = competences.length > 0;

  const handleConfirm = (event) => {
    event.preventDefault();
    if (!selected) return;
    onConfirm(selected);
  };

  return (
    <>
      <EscapeHandler func={onClose} />
      <Modal close={onClose}>
        <form
          className="financial-month-picker"
          role="dialog"
          aria-modal="true"
          aria-labelledby="financial-month-picker-title"
          onSubmit={handleConfirm}
        >
          <h3 id="financial-month-picker-title">Analisar mês com IA</h3>
          <p>
            A análise é feita sempre de um mês por vez e não altera o período nem os filtros
            da tela.
          </p>

          {hasOptions ? (
            <label className="financial-month-picker__field">
              <span>Mês</span>
              <select
                ref={selectRef}
                value={selected}
                onChange={(event) => setSelected(event.target.value)}
              >
                {competences.map((competence) => (
                  <option key={competence} value={competence}>
                    {competenceLabel(competence)}
                  </option>
                ))}
              </select>
            </label>
          ) : (
            <p className="financial-month-picker__empty" role="status">
              Nenhum mês com dado no período selecionado.
            </p>
          )}

          <div className="financial-month-picker__actions">
            <button type="button" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" disabled={!hasOptions || !selected}>
              Analisar
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default FinancialMonthPickerDialog;
